import React, { useState } from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";

import useStyles from "./ordersStyle";

import {
  Box,
  TableRow,
  Typography,
  Paper,
  ListItemText,
  TableCell,
  ListItem,
  ListItemAvatar,
  Divider,
} from "@mui/material";
import Button from "../../components/controls/Button";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import globalStyles from "../../style/global.js";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";

import { getOrdersData } from "../../redux/reduser/orders";
import PageTitle from "../../components/pageTitle/PageTitle";

function Orders() {
  const globalClasses = globalStyles();
  const { t } = useTranslation();
  const { data, loading, error } = useSelector((state) => state.orders);
  const classes = useStyles();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrdersData());
  }, []);

  function renderExpandableRow(rowData, rowMeta) {
    const colSpan = rowData.length + 1;
    return (
      <>
        <TableRow>
          <TableCell colSpan={rowData.length}>
            <Box >
              <Box className={classes.box}>
                <Paper className={classes.paper}>
                  <Typography gutterBottom variant="h5" color="primary" component="div">
                    {t("customer")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("name") + ": " + rowData[1]}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("phone") + ": " + "0795011273"}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("email") + ": " + "husseinayyad70@gmail.com"}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("location") + ": " + "amman-jordan"}
                  </Typography>
                </Paper>
              </Box>

              <Box className={classes.box}>
                <Paper className={classes.paper}>
                  <Typography gutterBottom variant="h5" color="primary"  component="div">
                    {t("products")}
                  </Typography>
                  <ListItem>
                    <ListItemAvatar>
                      <img
                        height="80px"
                        width="80px"
                        src={
                          "https://thumbs.dreamstime.com/b/no-image-available-icon-flat-vector-no-image-available-icon-flat-vector-illustration-132482930.jpg"
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText primary="book" secondary="$200" />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemAvatar>
                      <img
                        height="80px"
                        width="80px"
                        src={
                          "https://thumbs.dreamstime.com/b/no-image-available-icon-flat-vector-no-image-available-icon-flat-vector-illustration-132482930.jpg"
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText primary="book2" secondary="$300" />
                  </ListItem>
                </Paper>
              </Box>

              <Box className={classes.box}>
                <Paper className={classes.paper}>
                  <Typography gutterBottom variant="h5" color="primary" component="div">
                    {t("payment")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("paymentMethod") + ": " + "paypal"}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("status") + ": " + "success"}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    {t("totalAmount") + ": " + "$200"}
                  </Typography>
                </Paper>
              </Box>
            </Box>
          </TableCell>
        </TableRow>
      </>
    );
  }
  const columns = [
    { name: t("id") },
    { name: t("customer") },

    { name: t("status"),
  
    options: {
      
      customBodyRenderLite: (dataIndex) => {
        return (
          <>
        
          <Box className={classes.statusBox}>
             <Typography>{data[dataIndex][2]}</Typography>
          </Box>
           
          </>
        );
      },
    },
  },
    { name: t("date") },
    { name: t("totalAmount") },
    {
      name: t("action"),
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Button
                className={classes.btn}
                fullWidth="200px"
                color="primary"
                disabled={data[dataIndex][2] === "complete" ? true : false}
                onClick={() => {
                  const { data } = this.state;
                  data.shift();
                  this.setState({ data });
                }}
                text={t("accept")}
              />

              <Button
                className={classes.btn}
                fullWidth="200px"
                color="primary"
                disabled={
                  data[dataIndex][2] == "rejected" ||
                  data[dataIndex][2] == "complete"
                    ? true
                    : false
                }
                onClick={() => {
                  const { data } = this.state;
                  data.shift();
                  this.setState({ data });
                }}
                text={t("decline")}
              />
            </>
          );
        },
      },
    },
  ];

  return (
    <Box className={globalClasses.background}>
      <Box className={globalClasses.page}>
        <Box className={globalClasses.row}>
          <PageTitle title={t("orders")} />
        </Box>

        {loading === true ? (
          <div className={globalClasses.center}>
            {" "}
            <CircularProgressBar />{" "}
          </div>
        ) : error == null ? (
          <UseTable
            data={data}
            columns={columns}
            title={t("orders")}
            selectableRows={false}
            expandableRows={true}
            renderExpandableRow={renderExpandableRow}
          />
        ) : (
          <div className={globalClasses.center}>
            {" "}
            <ErrorMessage title={error} />{" "}
          </div>
        )}
      </Box>
    </Box>
  );
}
export default Orders;
